import I18n from 'I18n';
import { TIMESTAMP_DATE_FORMAT, TIMESTAMP_FORMAT, TIMESTAMP_SHORTHAND_FORMAT } from 'flow-doctor-lib/constants/Global';
import { fromString } from 'foundations-components/transitional/utils/SimpleDate';

// Only used on the WF details page for querying date ranges. But we need to calculate it here so we can
// deep link to specific dates
const SIMPLE_DATE_QUERY_PARAM_FORMAT = 'YYYY-MM-DD';

// No types yet for SimpleDate, but it's relatively straightforward so we can use transient types here

export const formatTimestampToPortalTz = timestamp => I18n.moment.portalTz(timestamp).format(TIMESTAMP_FORMAT);
export const formatTimestampToShorthandPortalTz = timestamp => I18n.moment.portalTz(timestamp).format(TIMESTAMP_SHORTHAND_FORMAT);
export const formatTimestampToUTCTzDate = timestamp => I18n.moment.utc(timestamp).format(TIMESTAMP_DATE_FORMAT);
export const ONE_MINUTE_MS = 60000;
export const ONE_DAY_MS = 1000 * 60 * 60 * 24;
const getMomentForTimezoneTimestamp = (timezone, timestamp) => {
  switch (timezone) {
    case 'UTC':
      return I18n.moment.utc(timestamp);
    case 'PORTAL_TZ':
      // Technically accepts undefined/no parameters
      return I18n.moment.portalTz(timestamp);
    case 'USER_TZ':
      // Technically accepts undefined/no parameters
      return I18n.moment.userTz(timestamp);
    default:
      throw new Error(`Bad timezone: ${timezone}`);
  }
};
export const getTimestampFromSimpleDate = (date, timezone) => {
  const momentDate = getMomentForTimezoneTimestamp(timezone);
  return momentDate.set({
    year: date.year,
    month: date.month,
    date: date.date,
    hour: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  }).valueOf();
};
export const getSimpleDateForTimestamp = (timestamp, timezone) => {
  const momentDate = getMomentForTimezoneTimestamp(timezone, timestamp);
  return fromString(momentDate.format('MM-DD-YYYY'), 'MM-DD-YYYY');
};
export const getMinutesRemainderFromTimestamp = (timestamp, timezone) => {
  const momentDate = getMomentForTimezoneTimestamp(timezone, timestamp);
  return momentDate.hours() * 60 + momentDate.minutes();
};

// Gets midnight the day of, for a given timestamp
export const getTopOfDateTimestamp = (timestamp, timezone) => {
  return new Date(timestamp).getTime() - getMinutesRemainderFromTimestamp(timestamp, timezone) * ONE_MINUTE_MS;
};

// Gets 23:59 the day of, for a given timestamp
export const getEndOfDateTimestamp = (timestamp, timezone) => {
  return getTopOfDateTimestamp(timestamp, timezone) - ONE_MINUTE_MS + ONE_DAY_MS;
};
export const getNDaysAgo = (numDaysAgo, timezone) => {
  const currentDate = getMomentForTimezoneTimestamp(timezone);
  return currentDate.subtract(numDaysAgo, 'days').valueOf();
};
export const toDetailsPageDateStringFromTimestamp = timestamp => {
  return I18n.moment.userTz(timestamp).format(SIMPLE_DATE_QUERY_PARAM_FORMAT);
};
export const getLogFetchDateStringForTimestamp = timestamp => {
  return I18n.moment.utc(timestamp).format('YYYY-MM-DDTHH:mm[Z]');
};